import { AuthenticationResponseCode, LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import { HandlerHttpResponseForAuthenticationService } from "@/function/handlerError";
import {
  GetAuthenticationErrorMessage,
  GetErrorMessageByExceptionCode,
  GetMessageExceptionCode,
} from "@/helper/shareHelper";
import { SetHeaderTableUser, SetTapsUserTable } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import { ConvertToUserDetail, ConvertToUserTable } from "@/service/user/userFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import textHelper from "../../helper/textHelper";

@Module({ namespaced: true })
export default class User extends VuexModule {
  private userTable: Array<any> = [];
  private userTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private headerUserTable: Array<any> = [];
  private tapsUserTable: Array<any> = SetTapsUserTable();
  private isHaveSupportUser = true;
  private removeUserLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private userDetail: any | null = null;
  private userDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private updateUserRoleLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private addNewUserLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private invitationId: number | null = null;
  private setForgotPwdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private forgotPwdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private resetForgotPwdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private forgotPwd: any | null = null;
  private lastestUpdateDatetime: any | null = null;
  private verifyCurrentPINData: any | null = null;
  private verifyCurrentPINRemainAttempt: any | null = null;
  private verifyCurrentPINLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private changePINLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getUserTable(): Array<any> {
    return this.userTable;
  }

  get getVerifyCurrentPINData(): any {
    return this.verifyCurrentPINData;
  }

  get getVerifyCurrentPINLoadingStatus(): LoadingStatusType {
    return this.verifyCurrentPINLoadingStatus;
  }

  get getUserTableLoadingStatus(): LoadingStatusType {
    return this.userTableLoadingStatus;
  }

  get getVerifyCurrentPINRemainAttempt(): any {
    return this.verifyCurrentPINRemainAttempt;
  }

  get getHeaderUserTable(): Array<any> {
    return this.headerUserTable;
  }

  get getTapsUserTable(): Array<any> {
    return this.tapsUserTable;
  }

  get getIsHaveSupportUser(): boolean {
    return this.isHaveSupportUser;
  }

  get getRemoveUserLoadingStatus(): LoadingStatusType {
    return this.removeUserLoadingStatus;
  }

  get getUserDetail(): any {
    return this.userDetail;
  }

  get getUserDetailLoadingStatus(): LoadingStatusType {
    return this.userDetailLoadingStatus;
  }

  get getUpdateUserRoleLoadingStatus(): LoadingStatusType {
    return this.updateUserRoleLoadingStatus;
  }

  get getAddNewUserLoadingStatus(): LoadingStatusType {
    return this.addNewUserLoadingStatus;
  }

  get getInvitationId(): number | null {
    return this.invitationId;
  }

  get getSetForgotPwdLoadingStatus(): LoadingStatusType {
    return this.setForgotPwdLoadingStatus;
  }

  get getForgotPwdLoadingStatus(): LoadingStatusType {
    return this.forgotPwdLoadingStatus;
  }

  get getForgotPwd(): any {
    return this.forgotPwd;
  }

  get getResetForgotPwdLoadingStatus(): LoadingStatusType {
    return this.resetForgotPwdLoadingStatus;
  }

  get getLastestUpdateDatetime(): any {
    return this.lastestUpdateDatetime;
  }

  @Mutation
  public SetUserTableLoadingStatus(status: LoadingStatusType) {
    this.userTableLoadingStatus = status;
  }

  @Mutation
  public MutationVerifyCurrentPINRemainAttempt(remainAttempt: any) {
    this.verifyCurrentPINRemainAttempt = remainAttempt;
  }

  @Mutation
  public MutationVerifyCurrentPINData(data: any) {
    this.verifyCurrentPINData = data;
    this.verifyCurrentPINLoadingStatus = LoadingStatusType.Success;
  }

  @Mutation
  public SetUserTable(userTable: any) {
    this.userTable = userTable.userTableDetails;
    this.isHaveSupportUser = userTable.isHaveSupportUser;
    this.lastestUpdateDatetime = userTable.lastestUpdateDatetime;
    this.tapsUserTable[0].length = userTable.allUserCount;
  }

  @Mutation
  public MutationVerifyCurrentPINLoadingStatus(status: LoadingStatusType) {
    this.verifyCurrentPINLoadingStatus = status;
  }

  @Mutation
  public SetHeaderUserTable(sorting: any = null) {
    this.headerUserTable = SetHeaderTableUser();
    if (sorting !== null) {
      this.headerUserTable.forEach((item) => {
        if (item.sortBy == sorting.sortBy) {
          item.sortingType = sorting.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }

  @Mutation
  public MutationClearVerifyCurrentPINData() {
    this.verifyCurrentPINData = null;
    this.verifyCurrentPINLoadingStatus = LoadingStatusType.None;
    this.verifyCurrentPINRemainAttempt = null;
  }

  @Mutation
  public SetRemoveUserLoadingStatus(status: LoadingStatusType) {
    this.removeUserLoadingStatus = status;
  }

  @Mutation
  public SetUserDetail(userDetail: any) {
    this.userDetail = userDetail;
  }

  @Mutation
  public SetUserDetailLoadingStatus(status: LoadingStatusType) {
    this.userDetailLoadingStatus = status;
  }

  @Mutation
  public SetUpdateUserRoleLoadingStatus(status: LoadingStatusType) {
    this.updateUserRoleLoadingStatus = status;
  }

  @Mutation
  public SetAddNewUserLoadingstatus(status: LoadingStatusType) {
    this.addNewUserLoadingStatus = status;
  }

  @Mutation
  public SetInvitationId(invitationId: number | null) {
    this.invitationId = invitationId;
  }

  @Mutation
  public SetForgotPwdLoadingStatus(status: LoadingStatusType) {
    this.setForgotPwdLoadingStatus = status;
  }

  @Mutation
  public SetGetForgotPwdLoadingStatus(status: LoadingStatusType) {
    this.forgotPwdLoadingStatus = status;
  }

  @Mutation
  public SetForgotPwd(forgotPwd: any) {
    this.forgotPwd = forgotPwd;
  }

  @Mutation
  public SetResetForgotPwdLoadingStatus(status: LoadingStatusType) {
    this.resetForgotPwdLoadingStatus = status;
  }

  @Action
  public DoGetUserTable(input: any) {
    if (this.userTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUserTableLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoGetSettingUserTable(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const userTable = ConvertToUserTable(res.data.userTable);
          this.context.commit("SetUserTable", userTable);
          this.context.commit("SetHeaderUserTable", {
            sortBy: input.transactionTableView,
            sortingType: input.tableSorting,
          });
        } else {
          const userTable = {
            isHaveSupportUser: false,
            userTableDetails: [],
            allUserCount: 0,
          };
          this.context.commit("SetHeaderUserTable", {
            sortBy: input.transactionTableView,
            sortingType: input.tableSorting,
          });
          this.context.commit("SetUserTable", userTable);
        }
        this.context.commit("SetUserTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoRemoveUser(input: any) {
    if (this.removeUserLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetRemoveUserLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoRemoveUser(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: input.merchantName
                ? i18n.t("Leave_Organization_MerchantName_Success", { merchantName: input.merchantName })
                : i18n.t("Delete_User_Complete"),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetRemoveUserLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetUserDetail(userId: number) {
    if (this.userDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUserDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.UserService.DoGetUserDetail(userId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const userDetail = ConvertToUserDetail(res.data.userRole);
          this.context.commit("SetUserDetail", userDetail);
        }
        this.context.commit("SetUserDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoUpdateUserRole(input: any) {
    if (this.updateUserRoleLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateUserRoleLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoUpdateUserRole(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Edited_Setting_Success", { name: i18n.t("User") }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateUserRoleLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoAddNewUser(userRoleDetail: any) {
    if (this.addNewUserLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetAddNewUserLoadingstatus", LoadingStatusType.Loading);
      API.UserService.DoAddNewUser(userRoleDetail).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetInvitationId", res.data.invitationId);
        } else {
          const alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetAddNewUserLoadingstatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoSetForgotPwd(username: string) {
    this.context.commit("SetForgotPwdLoadingStatus", LoadingStatusType.Loading);
    API.UserService.DoSetForgotPwd(username).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetForgotPwdLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("SetForgotPwdLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }

  @Action
  public DoGetForgotPwd(input: any) {
    this.context.commit("SetGetForgotPwdLoadingStatus", LoadingStatusType.Loading);
    const _input: any = {
      forgotPwdId: input.a,
      forgotPwdCode: input.b,
    };
    API.UserService.DoGetForgotPwd(_input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetForgotPwd", res.data.forgotPwd);
        this.context.commit("SetGetForgotPwdLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("SetGetForgotPwdLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }

  @Action
  public DoResetPwd(password: string) {
    this.context.commit("SetResetForgotPwdLoadingStatus", LoadingStatusType.Loading);
    const passwordToken = textHelper.CreateToken(password);
    const input = {
      forgotPwdId: this.forgotPwd.id,
      forgotPwdCode: this.forgotPwd.forgotPwdCode,
      password: passwordToken,
    };
    API.UserService.DoResetPwd(input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetResetForgotPwdLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("SetResetForgotPwdLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }

  @Action
  public ClearVerifyCurrentPINData() {
    this.context.commit("MutationClearVerifyCurrentPINData");
  }

  @Action
  public DoVerifyPINCode(input: any) {
    return new Promise<void>(async (resolve) => {
      if (this.verifyCurrentPINLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationVerifyCurrentPINLoadingStatus", LoadingStatusType.Loading);

        const handlerResponseSuccess = async (res: any) => {
          this.context.commit("MutationVerifyCurrentPINData", res.data.response);
        };
        const handlerExceptionDefault = async (exception: any) => {
          this.context.commit("MutationVerifyCurrentPINLoadingStatus", LoadingStatusType.Fail);
          if (exception) {
            // เก็บ remainAttempt
            if (exception.code === AuthenticationResponseCode.InvalidPINCode && exception.content?.remainAttempt) {
              this.context.commit("MutationVerifyCurrentPINRemainAttempt", exception.content.remainAttempt);
            }

            // เก็บ remainAttempt = 0 เมื่อถึงขีดจำกัด
            if (exception.code === AuthenticationResponseCode.VerifyPINCodeMaxAttemptReached) {
              this.context.commit("MutationVerifyCurrentPINRemainAttempt", 0);
            }

            const alertMessage = GetAuthenticationErrorMessage(exception);
            if (
              exception.code !== AuthenticationResponseCode.InvalidPINCode &&
              exception.code !== AuthenticationResponseCode.VerifyPINCodeMaxAttemptReached
            ) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
          }
        };
        const response = await API.UserService.DoVerifyPINCode(input);
        await HandlerHttpResponseForAuthenticationService(
          response,
          handlerResponseSuccess,
          handlerExceptionDefault,
          this.context
        );
      }
      resolve();
    });
  }
}
